/**
* 班级任务与个人完成情况
*/
<template>
    <span>

        <a-button :loading="loading" @click="openmodel" type="primary" style="margin-bottom: 10px;">班级成绩分析</a-button>

        <a-modal :visible="visible" :width="1280" title="班级总体数据分析信息" @ok="okmodel" @cancel="cancelmodel">
            <!--  -->

            <!--   {{tabledata}} -->

            <!-- {{tabledata}} -->

            <!-- {{searchFrom}} -->
            <!-- <a-divider></a-divider> -->
            <div class="main">


                <a-form layout="inline">
                    <a-form-item>
                        <a-form-item>
                            <a-select v-model="searchFrom.missiontype_id" placeholder="任务类型" style="width: 180px;"
                                allow-clear>
                                <a-select-option v-for="(item) in MissiontypeList" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                    </a-form-item>
                </a-form-item>
                <!-- <a-form-item>
                          <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" :placeholder="['任务开始时间', '任务结束时间']"
                              @ok="onChange" />
                      </a-form-item> -->

                    <a-form-item>
                        <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                    </a-form-item>
                </a-form>
                <!-- 单个柱状堆叠图表内容开始 -->
                <template>
                    <div>
                        <a-row class="row" :gutter="16" style="padding-bottom: 20px;">
                            <a-col :span="16">
                                <!-- <h2 class="title">学生信息</h2> -->

                                <div class="row" style="font-size: 20px;font-weight:bold;">
                                    班级名称:{{ itemdata.campusname + itemdata.gradename + itemdata.squadname }}</div>
                        </a-col>
                    </a-row>
                    <!-- <v-chart :forceFit="true" :height="height" :data="datas">
                <v-tooltip />
                <v-axis />
                    <v-legend />
                   <v-stack-bar position="name*value" color="type" />
                  </v-chart> -->

                        <v-chart :forceFit="true" :height="height" :data="datas" :scale="scale" :padding="padding">
                            <v-tooltip />
                          <v-axis dataKey="name" :label="{ offset: 18, textStyle: { rotate: 45, textAlign: 'end',fontWeight: 'bold', fontSize: 14 } }" />
                            <v-legend />

                            <v-bar position="name*数量" color="类型" :adjust="adjust" />
                            <v-smooth-line position="name*正确率" color="#fdae6b" :size="gemoSize" />
                            <v-point shape="circle" position="name*正确率" color="#fdae6b" :size="gemoSize" :label="label2" />
                        </v-chart>
                    </div>
                </template>
            </div>
        </a-modal>
    </span>
</template>
<script>

const DataSet = require('@antv/data-set');
const scale = [{
    dataKey: '正确率',
    min: 0,
    formatter: '.0%',
}];

export default {
    components: {},
    props: {//props是子组件访问父组件数据的唯一接口
        itemdata: {},
    },
    data() {
        return {
            // data,
            height: 600,
            adjust: [{
                type: 'dodge',
                marginRatio: 1 / 32,
            }],
            scale,
            padding: [40, 40, 200, 40],
            loading: false,
            visible: false,
            MissiontypeList: [],
            tabledata: [],
            gemoSize: 5,
            searchFrom: {
                // user_id: this.itemdata.user_id,
                grade_id: undefined,
                start_time: Number,
                end_time: Number,
                squad_id: this.itemdata.id,
                mission_type_id: undefined,
            },
            label2: ['正确率', {
                textStyle: {
                    fontSize: 20,
                    lineWidth: 1,
                    stroke: 'white',
                    fontWeight: 600
                }
            }],
        };
    },
    mounted() {
        // this.tableSearch();
    },
    computed: {
        datas() {
            //  let me = this
            const sourceData = [];
            this.tabledata.forEach(row => {
                row['总数'] = Number(row['all_cnt']);
                row['正确数'] = Number(row['right_cnt']);
                row['错误数'] = Number(row['error_cnt']);
                row['未做数'] = Number(row['no_cnt']);
                row['正确率'] = Number(row['accuracy']);
                row['已做数'] = Number(row['student_answer_cnt'])
                sourceData.push(row);
            });

            const dv = new DataSet.View().source(sourceData);
            dv.transform({
                type: 'fold',
                fields: ['总数', '正确数', '错误数', '已做数', '未做数'],
                key: '类型',
                value: '数量',
                retains: ['name', '类型', '正确率'],
            });
            const dataviser = dv.rows;
            return dataviser;
        },
    },
    methods: {

        onChange(value, dateString) {
            dateString,
                this.searchFrom.start_time = Number(value[0] / 1000);
            this.searchFrom.end_time = Number(value[1] / 1000);
        },
        getMissiontypeList() {
            this.$axios
                .post("/api/BasicMissionType/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.MissiontypeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        showStudentchaptermission() {
            this.$axios
                .post("/api/StatisticsReport/squadchapter", {
                    data: this.searchFrom,
                })

                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.tabledata = res.data
                        // this.res.data,
                        console.log(res.data);
                        //   this.studentSquadList = res.data;
                        this.squadList_visible = true;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },


        openmodel() {
            this.visible = true;
            this.getMissiontypeList();

            // this.showStudentmission();
            this.showStudentchaptermission();
            this.tableSearch();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        tableSearch() {
            //  this.showStudentmission();
            this.showStudentchaptermission();
        },

    }

};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
